import { classNames } from '@dimjs/utils';
import { CSSProperties, FC } from 'react';
import { numberPx2rem } from '../utils/pxrem';

export type GapProps = {
  className?: string;
  style?: CSSProperties;
  height?: number;
  bgColor?: CSSProperties['backgroundColor'];
};

/**
 * 间隙组件
 */
export const Gap: FC<GapProps> = (props) => {
  const remHeight = numberPx2rem(props.height);
  const style = { ...props.style, height: remHeight };
  if (props.bgColor) {
    style.backgroundColor = props.bgColor;
  }
  return <div style={style} className={classNames('v-gap', props.className)} />;
};
